module.exports = __webpack_public_path__ + "static/media/pod_inactive.de3377bb.svg";